module.exports = __webpack_public_path__ + "static/media/twilio.14b3f670.svg";